import { type Commands } from '../../../core/context/commands';
import { type CustomAttributeData } from './dto';
import { CustomAttribute } from './entity';
import { CustomAttributes } from './repository';

export class CustomAttributeCommands
    implements Commands<CustomAttributes, CustomAttribute, CustomAttributeData>
{
    addAll(
        repo: CustomAttributes,
        data: CustomAttributeData[],
    ): CustomAttributes {
        data.forEach((assumption) => this.add(repo, assumption));

        return repo;
    }

    add(repo: CustomAttributes, data: CustomAttributeData): CustomAttributes {
        const assumption = new CustomAttribute({ ...data });
        repo.add(assumption);
        return repo;
    }

    update(repo: CustomAttributes, entity: CustomAttribute): CustomAttribute {
        repo.update(entity);
        return entity;
    }

    remove(repo: CustomAttributes, id: string): void {
        repo.remove(id);
    }

    fromJSON(
        entity: CustomAttribute[],
        changeCallback: () => void,
    ): CustomAttributes {
        const assumptions = new CustomAttributes(changeCallback);
        entity.forEach((assumption) => {
            assumptions.add(new CustomAttribute({ ...assumption }));
        });
        return assumptions;
    }
}
